import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { INewTask, ITask, ITaskPayload, ITaskSummary, TestKit } from '../../entities/Tasks/Tasks.ts';

export class TasksApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Tasks`;

    public static apiUrls = {
        getTasks: `${TasksApi.baseApiUrl}`,
        getTasksById: `${TasksApi.baseApiUrl}/:id`,
        postTasks: `${TasksApi.baseApiUrl}`,
        putTasks: `${TasksApi.baseApiUrl}/:id/Complete`,
        deleteTasks: `${TasksApi.baseApiUrl}/:id`,
        sendReminderToUser: `${TasksApi.baseApiUrl}/:id/SendReminderToUser`,
        sendReminderToAssistant: `${TasksApi.baseApiUrl}/:id/SendReminderToAssistant`,
        getHasAssistant: `${TasksApi.baseApiUrl}/:id/HasAssistants`,
        getNewTask: `${TasksApi.baseApiUrl}/NewTask`,
        getTestKits: `${BaseApi.apiUrl}/TestKits/:id`,
        getTaskSummaries: `${BaseApi.apiUrl}/Patients/:id/TaskSummaries`,
        getTasksByPatient: `${BaseApi.apiUrl}/Patients/:id/Tasks`,
    };

    public static async getNewTask(): Promise<INewTask> {
        return this.sendApiRequest<INewTask>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getNewTask,
            data: undefined,
        });
    }

    public static async getTasks(facilityId?: number): Promise<ITask[]> {
        const query = facilityId ? `?facilityId=${facilityId}` : '';
        return this.sendApiRequest<ITask[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getTasks}${query}`,
        });
    }

    public static async getTasksByPatient(id: string): Promise<ITask[]> {
        return this.sendApiRequest<ITask[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getTasksByPatient,
            data: undefined,
            id: id,
        });
    }

    public static async getTaskSummaries(id: string): Promise<ITaskSummary[]> {
        return this.sendApiRequest<ITaskSummary[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getTaskSummaries,
            data: undefined,
            id: id,
        });
    }

    public static async getTaskById(id: string): Promise<ITask> {
        return this.sendApiRequest<ITask>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getTasksById,
            data: undefined,
            id: id,
        });
    }

    public static async getTestKits(id: string): Promise<TestKit> {
        return this.sendApiRequest<TestKit>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getTestKits,
            data: undefined,
            id: id,
        });
    }

    public static async postTasks(data: ITaskPayload): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postTasks,
            data: data,
        });
    }

    public static async putTask(id: string, data: { completionDate: Date }): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putTasks,
            data: data,
            id: id,
        });
    }

    public static async deleteTask(id: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deleteTasks,
            data: undefined,
            id: id,
        });
    }

    public static async sendReminderToUser(id: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.sendReminderToUser,
            id: id,
        });
    }

    public static async sendReminderToAssistant(id: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.sendReminderToAssistant,
            id: id,
        });
    }

    public static async getHasAssistant(id: string): Promise<boolean> {
        return this.sendApiRequest<boolean>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getHasAssistant,
            id: id,
        });
    }
}
